export default __webpack_public_path__ + "static/logoWhite-71d5c6707f6d91e7fe43f46c3ddd3cef.svg";